import InteriorDesignIcon from "../../assets/product-list-assets/interior-design.svg";
import type { ProductListGroup } from "../../types";

export const interiorDesign: ProductListGroup = {
  id: "interiorDesign",
  title: "productListGroup.interiorDesign.title",
  icon: {
    src: InteriorDesignIcon,
    width: 20,
    height: 21,
  },
};
